import { Builder } from '@builder.io/react';
import VideoPlayer from './VideoPlayer';

Builder.registerComponent(VideoPlayer, {
  name: 'VideoPlayer',
  friendlyName: 'LiveStream',
  inputs: [
    {
      name: 'sourceUrl',
      type: 'string',
      required: true,
    },
    {
      name: 'posterImage',
      type: 'file',
      allowedFileTypes: ['jpeg', 'png'],
    },
    {
      name: 'playing',
      type: 'boolean',
      defaultValue: true,
      hideFromUI: true,
    },
    {
      name: 'location',
      type: 'string',
      enum: [
        'London',
        'San Francisco',
      ],
      defaultValue: 'London',
    },
  ],
});
